import parsePhoneNumber from 'libphonenumber-js';
import { assertRequired, assertPhoneNumber } from '../validators';

export default (countryCode = 'US') => ({
  destinations: [],
  currentDestination: '',
  valid: true,
  cc: countryCode,

  init() {
    this.$watch('currentDestination', () => { this.softValidate(); });
  },

  get parsedPhoneNumber() {
    return parsePhoneNumber(this.currentDestination, this.cc);
  },

  get fullPhoneNumber() {
    return this.parsedPhoneNumber.format('E.164');
  },

  get phoneValid() {
    return assertRequired(this.currentDestination)
      && assertPhoneNumber(this.currentDestination, this.cc);
  },

  get countryCode() {
    if (this.currentDestination.length === 0) return this.cc;

    if (this.currentDestination.charAt(0) === '+' && !this.phoneValid) {
      return undefined;
    }

    if (!this.phoneValid) {
      return this.cc;
    }

    return this.parsedPhoneNumber.country;
  },

  get flag() {
    if (!this.countryCode) return '🏳️';

    const codePoints = this.countryCode
      .toUpperCase()
      .split('')
      .map((char) => (127397 + char.charCodeAt()));
    return String.fromCodePoint(...codePoints);
  },

  hardValidate() {
    this.currentDestination = this.currentDestination.trim();
    this.valid = this.phoneValid;
  },

  softValidate() {
    this.currentDestination = this.currentDestination.trim();
    if (!this.valid) {
      this.valid = this.phoneValid;
    }
  },

  closeDialog() {
    this.$refs.dialog.close();
  },

  success() {
    if (this.$event.detail.success) {
      this.closeDialog();
    }
  },

  addDestination() {
    this.hardValidate();
    if (this.phoneValid) {
      const existingPhoneIdx = this.destinations.findIndex(
        (p) => p.value === this.fullPhoneNumber,
      );
      if (existingPhoneIdx >= 0) {
        this.destinations.splice(existingPhoneIdx, 1);
      }
      this.destinations.unshift({ name: this.currentDestination, value: this.fullPhoneNumber });
      this.currentDestination = '';
      this.valid = true;
    }
  },

  cancelIfNoDestinations(event) {
    this.addDestination();
    if (this.destinations.length === 0) {
      event.preventDefault();
    }
  },
});
